(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hall-of-fame"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const grid = document.querySelector('.bestseller-grid');
  if (grid && window.innerWidth <= 768) {
    grid.addEventListener('wheel', (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault();
        grid.scrollLeft += e.deltaY;
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-character-overflow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.character-container');
  
  containers.forEach(container => {
    if (window.innerWidth <= 768) {
      container.addEventListener('wheel', (e) => {
        if (e.deltaY !== 0) {
          e.preventDefault();
          container.scrollLeft += e.deltaY;
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-worlds"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const grid = document.querySelector('.style-grid');
  if (grid && window.innerWidth <= 767) {
    grid.addEventListener('wheel', (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault();
        grid.scrollLeft += e.deltaY;
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
